<template>
<div class="guide-head">
    <div class="tips" v-text="tips" v-if="tips"></div>
    <div class="title" v-text="title"></div>
</div>
</template>

<script>
export default {
  name: 'GuideHead',
  props: ['title', 'tips'],
};
</script>

<style lang="less" scoped>
@import  '../../../assets/less/variable';

.guide-head {
    border-bottom: 1px solid @blue;
    padding-bottom: 10px;
    margin-bottom: 20px;
    .title {
        font-size: 18px;
        line-height: 18px;
        color: @blue;
    }
    .tips {
        float: right;
        font-size: 12px;
        line-height: 12px;
        color: #f1485b;
        margin-top: 6px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/component/GuideHead.vue